import Utils from "../../../utility";

const initialState = {
  mappings: [],
  fetched: false,
};

export const vendorStoreMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.VENDOR_STORE_MAPPING:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
